import {useState, useEffect, useCallback} from "react"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormContext } from "../context/FormContext";

import { TRAMITACIONES_EXTERNAS_INICIAL } from '../utils/initialStates';

import InfoButtonWithPopover from "./InfoButtonWithPopover";
import TramitacionExternaRow from "./TramitacionExternaRow";

import { Input, Label } from "../components/ui" //, Button, Select_simple
//import { optionsPartido, optionsTipoSubsidio, optionsEncargadoProyecto, optionsPrograma, optionsTipoContratacion, optionsTipoProyecto } from "../datos/options"

//import io from "socket.io-client"; //13-ENE-25
import { requisitos } from '../datos/requisitos';

/*const FormB_Tramitacion = ({
    registro, setRegistro, 
    handleCheckboxChange, observacionesReporteEntidad, // Recibe el estado como prop
    handleObservacionesReporteEntidadChange, // Recibe la función manejadora como prop
    observacionesInternas, // Recibe el estado como prop
    handleObservacionesInternasChange,
    observacionesTramitacionExterna, // 7agos-2025: Recibe el estado como prop
    handleObservacionesTramitacionExternaChange, // 7agos-2025: Recibe la función manejadora como prop

    // Estados y manejadores para Requisitos -12-jun-2025
    selectedRequisitos = {},
    onRequisitoChange = () => {},

    // Estados y manejadores para Tramitaciones Internas -12-jun-2025
    tramitacionesInternas = {},
    onTramitacionesInternasChange = () => {},

    // Estados y manejadores para Fechas de Tramitación Externa -22-jul-2025
    fechaSalidaConvenio,
    setFechaSalidaConvenio,
    fechaFirmaConvenio,
    setFechaFirmaConvenio,
    fechaSalidaResolucion,
    setFechaSalidaResolucion,
    fechaFirmaResolucion,
    setFechaFirmaResolucion,

    //para tramitaciones externas
    tramitacionesExternas = [],
    onUpdateTramitacion = () => {}
    
    
}) => { */
const FormB_Tramitacion = () => { 
    // Obtener los datos del contexto
    const { 
        formB, 
        updateField,
        updateObservacion,
        updateTramitaciones,
        updateTramitacionInterna,
        formA  // Para acceder a los datos de formA si son necesarios
    } = useFormContext();

    // Extraer los valores necesarios de formA
    const {
        datosGenerales = {},
        array_obras_expediente = []
    } = formA;

    // Extraer los valores necesarios de formB
    const {
        //observacionesReporteEntidad = '',
        //observacionesInternas = '',
        //observacionesTramitacionExterna = '',
        selectedRequisitos = {},
        tramitacion = {},
        //tramitacionesExternas = [],
        fechaSalidaConvenio,
        fechaFirmaConvenio,
        fechaSalidaResolucion,
        fechaFirmaResolucion
    } = formB;

    const tramitacionesExternas = formB?.tramitacionesExternas || [];
    console.log('Render tramitacionesExternas de FormB', tramitacionesExternas);

    const observacionesReporteEntidad = formB?.observaciones?.reporteEntidad;
    const observacionesInternas = formB?.observaciones?.internas;
    const observacionesTramitacionExterna = formB?.observaciones?.tramitacionExterna;

    
    //console.log('Registro completo:', registro);
    //PENDIENTE: Revisar si hace falta pasar todo el registro, o solo tipo_subsidio y area_responsable (27-jul-25)

    console.log("selectedRequisitos----->", selectedRequisitos)

    /*const tipo_subsidio_formA = registro?.formA?.tipo_subsidio || 'No especificado';
    const modalidad_formA = registro?.modalidad || '';
    const area_responsable_formA = registro?.formA?.area_responsable || 'No especificado';
    const array_obras_expedienteL = registro?.array_obras_expediente || ''; //es el dato que viene desde IniciPage en registro
    */

    // Por:
    const tipo_subsidio_formA = formA?.tipo_subsidio || 'No especificado';
    const modalidad_formA = formA?.modalidad || '';
    const area_responsable_formA = formA?.area_responsable || 'No especificado';
    const array_obras_expedienteL = formA?.array_obras_expediente || [];

    // Estados locales para UI
    const [tipoSubsidio, setTipoSubsidio] = useState(tipo_subsidio_formA); 
    const [modalidad, setModalidad] = useState(modalidad_formA);
    const [areaResponsable, setAreaResponsable] = useState(area_responsable_formA);
    //ESTADOS LOCAL - para contador de caracteres
    const [textInput1, setTextInput1] = useState(''); //input observacionesReporteEntidad
    const [textInput2, setTextInput2] = useState(''); //input observacionesInternas
    const [textInput3, setTextInput3] = useState(''); //input observacionesTramitacionExterna
    
    // En formB_Tramitacion.jsx
    useEffect(() => {
        if (array_obras_expediente?.length > 0) {
            const nuevasTramitaciones = array_obras_expediente.map((expediente, index) => {
                // Buscar si ya existe una tramitación con el mismo expediente
                const tramitacionExistente = tramitacionesExternas.find(
                    t => t.exp === expediente.expediente_o
                );

                // Si existe, mantener sus datos; si no, crear una nueva
                return tramitacionExistente || {
                    ...TRAMITACIONES_EXTERNAS_INICIAL[0],
                    exp: expediente.expediente_o || '',
                    objeto: expediente.objeto_o || '',
                    id: Date.now() + index // ID único para cada tramitación
                };
            });

            // Actualizar solo si hay cambios
            if (JSON.stringify(nuevasTramitaciones) !== JSON.stringify(tramitacionesExternas)) {
                updateTramitaciones('externas', nuevasTramitaciones);
            }
        } else if (tramitacionesExternas.length > 0) {
            updateTramitaciones('externas', []);
        }
    }, [array_obras_expediente]); // Elimina tramitacionesExternas de las dependencias
    
    // Efecto para actualizar el estado cuando cambia el registro
    //SE VA
    /*useEffect(() => {
        if (registro) {
            const newTipoSubsidio = registro.tipo_subsidio || '';
            const newAreaResponsable = registro.area_responsable || '';
            
            // Actualizar estados locales primero
            setTipoSubsidio(newTipoSubsidio);
            setAreaResponsable(newAreaResponsable);
        }
    }, [registro]);*/
    // Por:
    useEffect(() => {
        if (formA) {
            const newTipoSubsidio = formA.tipo_subsidio || '';
            const newAreaResponsable = formA.area_responsable || '';
            setTipoSubsidio(newTipoSubsidio);
            setAreaResponsable(newAreaResponsable);
        }
    }, [formA]);  

    // Formatear fecha para mostrar
    const formatDate = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleDateString('es-AR');
    };
    
    
    // Definición de los requisitos con sus condiciones
    /*const requisitos = [
        // Subtítulo Etapa I
        {
            id: 'etapa_i',
            label: 'ETAPA I',
            isSectionHeader: true,
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'nota_solicitud',
            label: 'Nota de solicitud',
            // Siempre visible
            isEnabled: () => true
        },
        {
            id: 'informe_dominio',
            label: 'Informes de dominio',
            // Habilitado solo para Área de Proyectos
            isEnabled: () => areaResponsable === 'ÁREA DE PROYECTOS'
        },
        {
            id: 'designacion_intendente',
            label: 'Designación Intendente',
            // Habilitado solo para Subsidio a municipio
            isEnabled: () => tipoSubsidio === 'Subsidio a municipio'
        },
        {
            id: 'anexo_social',
            label: 'Anexo social',
            // Habilitado para Área de Proyectos o Área de Microcréditos
            isEnabled: () => 
                areaResponsable === 'ÁREA DE PROYECTOS' 
        },
        {
            id: 'anexo_tecnico',
            label: 'Anexo técnico',
            // Habilitado para Área de Proyectos o Área de Microcréditos
            isEnabled: () => 
                areaResponsable === 'ÁREA DE PROYECTOS' 
        },
        {e
            id: 'computo_y_presupuesto',
            label: 'Cómputo y presupuesto',
            // Habilitado para Área de Proyectos o Área de Microcréditos
            isEnabled: () => 
                areaResponsable === 'ÁREA DE PROYECTOS' 
        },
        {
            id: 'proyecto_planos',
            label: 'Proyectos / Planos',
            // siempre visible
            isEnabled: () => true
        },
        {
            id: 'prefactibilidad_es_de_servicio_s_suscripta_prestataria',
            label: 'Prefactibilidad/es de servicio/s suscripta por la prestataria',
            // Habilitado para Área de Proyectos o Área de Microcréditos
            isEnabled: () =>
                areaResponsable === 'ÁREA DE PROYECTOS' 
        },
        {
            id: 'constancia_de_cbu',
            label: 'Constancia de CBU',
            // Habilitado para Área de Proyectos o Área de Microcréditos
            isEnabled: () => true
        },
        {
            id: 'acta_acuerdo',
            label: 'Acta acuerdo',
            // Habilitado para Área de Proyectos
            isEnabled: () => 
                areaResponsable === 'ÁREA DE PROYECTOS' 
        },
        {
            id: 'nota_regulacion_dominal',
            label: 'Nota Regulación Dominial',
            // Habilitado para Área de Mejoras o Área de Microcréditos
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS'  
                // quitamos esta condicion -----> || areaResponsable === 'ÁREA DE MICROCRÉDITOS'
        },
        {
            id: 'nota_certificacion_pago_arquitecto_mmdo',
            label: 'Nota Certificacion Pago Arquitecto/MMdO',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                tipoSubsidio === 'Subsidio a ONG' && 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'convenio_con_certificado',
            label: 'Convenio con certificado',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'pago_a_certificador',
            label: 'Pago a certificador',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'informe_final',
            label: 'Informe final',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'listado_beneficiarios',
            label: 'Listado Beneficiarios',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'pago_a_beneficiarios',
            label: 'Pago a Benficiarios',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'anexo_fotografico',
            label: 'Anexo Fotográfico',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        // Subtítulo Etapa II
        {
            id: 'etapa_ii',
            label: 'ETAPA II',
            isSectionHeader: true,
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'nota_solicitud_e2',
            label: 'Nota solicitud E2',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'proyecto_e2',
            label: 'Proyecto E2',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },        
        {
            id: 'nota_gastos_operativos',
            label: 'Nota Gastos Operativos',
            // Habilitado solo para Subsidio a ONG y Área de Mejoras
            isEnabled: () => 
                tipoSubsidio === 'Subsidio a ONG' && 
                areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'comprobante_microcredito',
            label: 'Comprobante microcrédito o factura',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'informe_rendiciones',
            label: 'Informe Rendiciones',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'ddjj',
            label: 'DDJJ',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'acuerdo_mutuo',
            label: 'Acuerdo Mutuo',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'nomina_beneficiarios',
            label: 'Nomina de Beneficiarios',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        },
        {
            id: 'plan_financiamiento',
            label: 'Plan de Financiamiento',
            // Habilitado para Área de Mejoras
            isEnabled: () => 
                areaResponsable === 'ÁREA DE MEJORAS' 
        }        
    ];*/

    // Requisitos de tramitación interna
    const tramitacionInterna = [
        {
            id: 'registracion_ong',
            label: 'Registración ONG',
            //isEnabled: () => tipoSubsidio && tipoSubsidio === 'Subsidio a ONG'
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                return tipo === 'Subsidio a ONG';
            }
        },
        {
            id: 'resolucion_ong',
            label: 'Resolución ONG',
            //isEnabled: () => tipoSubsidio === 'Subsidio a ONG'
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                return tipo === 'Subsidio a ONG';
            }
        },
        {
            id: 'documentacion_ong',
            label: 'Documentación ONG',
            //isEnabled: () => tipoSubsidio === 'Subsidio a ONG'
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                return tipo === 'Subsidio a ONG';
            }
        },
        //Informe Técnico siempre visible (nuevo requisito 22-jul-2025)
        {
            id: 'informe_tecnico',
            label: 'Informe Técnico',
            isEnabled: () => true
        },
        {
            id: 'modelo_convenio',
            label: 'Modelo de convenio',
            //isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'proyecto_resolucion',
            label: 'Proyecto de resolución',
            //isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },        
        /* por ahora sin casos especiales
        {
            id: 'desembolso',
            label: 'Desembolso + fecha',
            hasDate: true,// Indica que este ítem tiene un campo de fecha
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: '90_dias',
            label: '90 dias el + fecha',
            hasDate: true,// Indica que este ítem tiene un campo de fecha
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'mail_contacto',
            label: 'Mail contacto + cuadro abierto',
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'firma_convenio',
            label: 'Firma convenio + fecha',
            hasDate: true,// Indica que este ítem tiene un campo de fecha
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'convenio_escaneado',
            label: 'Convenio escaneado',
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        */ 
        {
            id: 'dni_presidente_ong',
            label: 'DNI Presidente',
            /*isEnabled: () => 
                tipoSubsidio === 'Subsidio a ONG' && 
                (areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS')*/
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                const area = datosGenerales.area_responsable;
                return tipo === 'Subsidio a ONG' && (area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS');
            }
        },
        {
            id: 'dni_intendente',
            label: 'DNI Intendente',
            /*isEnabled: () => 
                tipoSubsidio === 'Subsidio a municipio' && 
                (areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS')*/
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                const area = datosGenerales.area_responsable;
                return tipo === 'Subsidio a municipio' && (area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS');
            }
        },
        {
            id: 'poliza',
            label: 'Póliza',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'cbu',
            label: 'CBU',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'nota_solicitud',
            label: 'Nota de solicitud',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'acta_designacion',
            label: 'Acta designación',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'programa',
            label: 'Programa',
            // Siempre habilitado
            isEnabled: () => true
        },
             
        // Separador entre Programa y Resolución
        {
            id: 'separador',
            label: <hr className="border-gray-300" />,
            isEnabled: () => true,
            isSeparator: true
        },
        {
            id: 'resolucion',
            label: 'Resolución',
            // Siempre habilitado
            isEnabled: () => true
        },
        {
            id: 'documentacion_pago_ok',
            label: 'Documentación para el pago',
            isEnabled: () => true
        }
    ];

    const tramitacionInternaSeleccionada = tramitacionInterna
        .filter(item => tramitacion && tramitacion[item.id])
        .map(item => item.label)
        .join(', ');

    // Obtener lista de requisitos seleccionados para mostrar
    const requisitosSeleccionados = requisitos
        .filter(req => selectedRequisitos && selectedRequisitos[req.id])
        .map(req => req.label)
        .join(', ');




    // Manejar cambios en los checkboxes ---->ahora se maneja en el padre
    /*const handleRequisitoChange = (requisitoId, isChecked) => {
        setSelectedRequisitos(prev => ({
            ...prev,
            [requisitoId]: isChecked
        }));
        
        // Si se desmarca un campo de fecha, limpiar la fecha
        if (!isChecked && (requisitoId === 'desembolso_fecha' || requisitoId === '90_dias_fecha' || requisitoId === 'firma_convenio_fecha')) {
            setFechasRequisitos(prev => ({
                ...prev,
                [requisitoId]: null
            }));
        }
    };*/
    
    // Manejar cambio de fechas ---->ahora se maneja en el padre
    /*const handleFechaChange = (requisitoId, date) => {
        setFechasRequisitos(prev => ({
            ...prev,
            [requisitoId]: date
        }));
    };*/
    
    // Manejar cambio de email de contacto ---->ahora se maneja en el padre
    /*const handleEmailChange = (e) => {
        setEmailContacto(e.target.value);
    };*/    
    
    //El estado se define en el padre, pero igualmente se crean la lista de los items 
    /*const items = [
        "Nota de solicitud",
        "Informes de dominio",
        "Registración ONG",
        "Designación Intendente",       
        "Anexo social",
        "Anexo técnico",
        "Cómputo y presupuesto",
        "Planos de proyecto",
        "Prefactibilidad/es de servicio/s suscripta por la prestataria",
        "Constancia de CBU",        
        "Acta acuerdo"
    ];*/
    const items = [
        { label: "Nota de solicitud", value: "nota_de_solicitud" },
        { label: "Informes de dominio", value: "informes_de_dominio" },
        { label: "Registración ONG", value: "registracion_ong" },
        { label: "Designación Intendente", value: "designacion_intendente" },
        { label: "Anexo social", value: "anexo_social" },
        { label: "Anexo técnico", value: "anexo_tecnico" },
        { label: "Cómputo y presupuesto", value: "computo_y_presupuesto" },
        { label: "Planos de proyecto", value: "planos_de_proyecto" },
        { label: "Prefactibilidad/es de servicio/s suscripta por la prestataria", value: "prefactibilidad_es_de_servicio_s_suscripta_prestataria" },
        { label: "Constancia de CBU", value: "constancia_de_cbu" },
        { label: "Acta acuerdo", value: "acta_acuerdo" }
    ]
    
    useEffect(()=>{ // 9 -FEB-25 mantener: cambios desde registro
        setTipoSubsidio(tipo_subsidio_formA)

    }, [formA])//registro

    
    /* como netar durnate la migracion #2dic25
    useEffect(() => { // Nuevo useEffect para resetear valores al cambiar tipoSubsidio
        if (tipoSubsidio) {
            // Determinar si "Registración ONG" debe estar deshabilitado
            const isRegistracionOngDisabled = tipoSubsidio !== "Subsidio a ONG";
            // Determinar si "Designación Intendente" debe estar deshabilitado
            const isDesignacionIntendenteDisabled = tipoSubsidio !== "Subsidio a municipio";

            console.log(`[useEffect] tipoSubsidio: ${tipoSubsidio}`); // Log del tipoSubsidio actual


            // Si "Registración ONG" se deshabilita y estaba seleccionado, resetear su valor
            if (isRegistracionOngDisabled && selectedRequisitos["registracion_ong"]) {
                handleCheckboxChange("registracion_ong", false);
            }
            // Si "Designación Intendente" se deshabilita y estaba seleccionado, resetear su valor
            if (isDesignacionIntendenteDisabled && selectedRequisitos["designacion_intendente"]) {
                handleCheckboxChange("designacion_intendente", false);
            }
        }
    }, [tipoSubsidio, selectedRequisitos, handleCheckboxChange]); // Dependencias del useEffect: tipoSubsidio, selectedItems y handleCheckboxChange
    */

    //contador de caracteres #19NOV25:
    //podría definir un limite constante, pero de esta manera se puede usar para cualquier input e ir variando el limite
    /*const contadorCaracteresRestantes = (limite, longitudActual) => {
        if(limite && longitudActual){
            //a limite restarle la longitud actual
            const restantes = limite - longitudActual;
            return restantes;
        }
        return limite;
    }*/
    const contadorCaracteresRestantes = (limite, texto) => {
        // Si el texto es null o undefined, usar string vacío
        const longitud = texto ? texto.length : 0;
        // Asegurarse de que el límite sea un número válido
        const limiteValido = limite || 0;
        // Calcular caracteres restantes, asegurando que no sea negativo
        return Math.max(0, limiteValido - longitud);
    }
    //NUEVA #19NOV
    /*
    const handleInputChange = useCallback((event) => {
        const { name, value } = event.target;
        //console.log("name", name)
        //console.log("value", value)

        // Actualiza una parte del 'registro' existente, manteniendo la inmutabilidad
        //agregar casos especiales
        if (name === 'observacionesReporteEntidad') {
            //primero actualizamos el estado local para el contador
            setTextInput1(value);
            handleObservacionesReporteEntidadChange(event);
        } else if (name === 'observacionesInternas') {
            //primero actualizamos el estado local para el contador
            setTextInput2(value);
            handleObservacionesInternasChange(event);
        } else if (name === 'observacionesTramitacionExterna') {
            //primero actualizamos el estado local para el contador
            setTextInput3(value);
            handleObservacionesTramitacionExternaChange(event);
        }
    }, [registro]);
    */ 
   // Manejadores actualizados para usar el contexto
    const handleObservacionesReporteEntidadChange = (e) => {
        const value = e.target.value;
        setTextInput1(value);
        updateObservacion('reporteEntidad', value);
    };

    const handleObservacionesInternasChange = (e) => {
        const value = e.target.value;
        setTextInput2(value);
        updateObservacion('internas', value);
    };

    const handleObservacionesTramitacionExternaChange = (e) => {
        const value = e.target.value;
        setTextInput3(value);
        updateObservacion('tramitacionExterna', value);
    };

    const handleRequisitoChange = (requisitoId, isChecked) => {
        updateField('formB', 'selectedRequisitos', requisitoId, isChecked);
    };

    const handleTramitacionInternaChange = (field, value) => {
        updateTramitacionInterna({
            ...tramitacion,
            [field]: value
        });
    };
    
    const handleTramitacionExternaUpdate = useCallback((tramitacionId, updates) => { //updatedTramitacion
        if (!tramitacionId || !updates) return;
        console.log("LEON updates", updates)
        
        const tramitacionesActuales = [...tramitacionesExternas];
        console.log("LEON tramitacionesActuales", tramitacionesActuales)
        const index = tramitacionesActuales.findIndex(t => t.id === tramitacionId);
        
        if (index === -1) {
            // Si no existe, agregar con un ID único
            tramitacionesActuales.push({
                ...updates,
                id: tramitacionId || Date.now()
            });
        } else {
            console.log("LEON actualizar", index)
            // Si existe, actualizar
            tramitacionesActuales[index] = {
                ...tramitacionesActuales[index],
                ...updates
            };
        }
        
        updateTramitaciones('externas', tramitacionesActuales);
    }, [tramitacionesExternas, updateTramitaciones]);

    useEffect(() => {
        console.log('Estado actual de tramitacionesExternas:', tramitacionesExternas);
    }, [tramitacionesExternas]);


    return (
        <div className="p-4 bg-white dark:bg-gray-900 min-h-screen">
            <div className="flex flex-row">	
                <h2 className="text-xl font-bold dark:text-white mb-2">TRAMITACIÓN</h2>                               
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <Label htmlFor="tipoSubsidio">Tipo de subsidio</Label>
                    <div className="mt-2">
                        <Input
                            disabled={true}
                            id="tipoSubsidio"
                            name="tipoSubsidio"
                            placeholder="Tipo de subsidio"
                            value={datosGenerales.tipo_subsidio}
                        />
                    </div>
                </div>
                
                <div>
                    <Label htmlFor="areaResponsable">Area responsable</Label>
                    <div className="mt-2">
                        <Input
                            disabled={true}
                            id="areaResponsable"
                            name="areaResponsable"
                            placeholder="Area responsable"
                            value={datosGenerales.area_responsable || ''}
                        />
                    </div>
                </div>
            </div>
            

            
            <div className="mt-6">
                <h3 className="text-lg font-semibold mb-4">Documentación</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Columna de Requisitos */}
                    <div className="space-y-3">
                        <h4 className="text-md font-semibold mb-3 text-gray-700">Requisitos</h4>
                        <div className="space-y-2 max-h-[500px] overflow-y-auto p-2 border rounded">
                            {requisitos.map((requisito) => {
                                const isEnabled = requisito.isEnabled(datosGenerales.area_responsable, datosGenerales.tipo_subsidio);
                                
                                if (requisito.isSectionHeader) {
                                    if (datosGenerales.area_responsable === 'ÁREA DE MEJORAS') {
                                        return (
                                            <div key={requisito.id} className="mt-4 mb-2">
                                                <h5 className="font-bold text-blue-700">{requisito.label}</h5>
                                            </div>
                                        );
                                    }
                                    return null; // No mostrar el encabezado si no es ÁREA DE MEJORAS
                                }

                                return (
                                    <>
                                    {isEnabled && (
                                        <div key={requisito.id} className="flex items-center">
                                            <input
                                                type="checkbox"
                                                id={`requisito-${requisito.id}`}
                                                checked={selectedRequisitos[requisito.id] || false}
                                                //onChange={(e) => onRequisitoChange(requisito.id, e.target.checked)} 
                                                onChange={(e) => handleRequisitoChange(requisito.id, e.target.checked)}
                                                disabled={!isEnabled}
                                                className={`h-4 w-4 rounded border-gray-300 ${!isEnabled ? 'opacity-50' : 'text-blue-600'}`}
                                            />
                                            <label
                                                htmlFor={`requisito-${requisito.id}`}
                                                className={`ml-2 text-sm ${!isEnabled ? 'text-gray-500' : 'text-gray-700'}`}
                                            >
                                                {requisito.label}
                                                {!isEnabled && ' (No aplica)'}
                                            </label>
                                        </div>
                                    )}                                    
                                    </>
                                );
                            })}
                        </div>
                        {requisitosSeleccionados && (
                            <p className="mt-3 p-2 bg-blue-50 text-blue-800 rounded-md text-sm">
                                <span className="font-medium">Seleccionados:</span> {requisitosSeleccionados}
                            </p>
                        )}
                    </div>

                    {/* Columna de Tramitación Interna */}
                    <div className="space-y-3">
                        <div className="flex flex-row">
                            <h4 className="text-md font-semibold mb-3 text-gray-700">Tramitación Interna</h4>
                            <InfoButtonWithPopover infoText="EN TESTEO." />
                        </div>
                        
                        <div className="space-y-2 max-h-[500px] overflow-y-auto p-2 border rounded">
                            {(tramitacionInterna || []).map((item) => {
                                const isEnabled = item.isEnabled();
                                const isChecked = tramitacion[item.id] || false;
                                
                                // Renderizar campos especiales //COMENTAR 22-JUL-2025: por ahora no se usa
                                const renderSpecialField = () => {
                                    if (['desembolso', '90_dias', 'firma_convenio'].includes(item.id) && isChecked) {
                                        return (
                                            <DatePicker
                                                //selected={fechasTramitaciones[item.id] || null}
                                                selected={tramitacion[`${item.id}_fecha`] || null}
                                                //onChange={(date) => onTramitacionesInternasChange(`${item.id}_fecha`, date)} //onFechaTramitacionChange
                                                onChange={(date) => handleTramitacionInternaChange(
                                                    `${item.id}_fecha`, 
                                                    date
                                                )}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Seleccionar fecha"
                                                className="ml-3 text-sm border rounded p-1 w-40"
                                                disabled={!isEnabled}
                                            />
                                        );
                                    }
                                    
                                    if (item.id === 'mail_contacto' && isChecked) {
                                        return (
                                            <input
                                                type="email"
                                                value={tramitacion.mail_contacto_correo || ''}//{emailContacto}
                                                //onChange={(e) => onTramitacionesInternasChange('mail_contacto_correo', e.target.value)}//{onEmailContactoChange}
                                                onChange={(e) => handleTramitacionInternaChange('mail_contacto_correo', e.target.value)}
                                                placeholder="Ingrese el correo"
                                                className="ml-3 text-sm border rounded p-1 w-64"
                                                disabled={!isEnabled}
                                            />
                                        );
                                    }                                    
                                    return null;
                                }; //hasta acá no se usa (22-jul-2025)
                                
                                // Si es un separador, mostrarlo como un <hr> sin checkbox
                                if (item.id === 'separador') {
                                    return (
                                        <div key={item.id} className="my-2">
                                            <hr className="my-4 border-gray-300" />
                                        </div>
                                    );
                                }
                                
                                // Para los demás elementos, mostrar el checkbox normal
                                return (
                                    <>
                                    {isEnabled && (
                                        <div key={item.id} className="mb-2">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id={`tramitacion-${item.id}`}
                                                    checked={isChecked}
                                                    //checked={!!tramitacionesInternas[item.id]}
                                                    //onChange={(e) => onTramitacionesInternasChange(item.id, e.target.checked)}
                                                    onChange={(e) => handleTramitacionInternaChange(item.id, e.target.checked)}
                                                    className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                    disabled={!isEnabled}
                                                />
                                                <label 
                                                    htmlFor={`tramitacion-${item.id}`}
                                                    className={`ml-2 text-sm whitespace-nowrap ${!isEnabled ? 'text-gray-500' : 'text-gray-700'}`}
                                                >
                                                    {item.id === '90_dias_fecha' ? '90 días el' : item.id === 'mail_contacto' ? 'Mail de contacto' : item.label}
                                                    {!isEnabled && ' (No aplica)'}
                                                </label>
                                                {/*renderSpecialField() //COMENTAR 22-JUL-2025: por ahora no se usa*/} 
                                            </div>
                                        </div>
                                    )}
                                    </>
                                );
                            })}                             
                        </div>
                        {tramitacionInternaSeleccionada && (
                            <p className="mt-3 p-2 bg-blue-50 text-blue-800 rounded-md text-sm">
                                <span className="font-medium">Seleccionados:</span> {tramitacionInternaSeleccionada}
                            </p>
                        )}
                        
                    </div>
                </div>
            </div>

            

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                    
                <div>
                    <Label htmlFor="observacionesReporteEntidad">Observaciones para reporte a la entidad solicitante</Label>
                    <div className="mt-2">
                        <textarea
                            id="observacionesReporteEntidad"
                            name="observacionesReporteEntidad"
                            placeholder="Ingrese observaciones para reporte a la entidad solicitante"
                            rows="4"
                            value={observacionesReporteEntidad}
                            maxLength="2000"
                            onChange={handleObservacionesReporteEntidadChange}
                            //onChange={e => handleInputChange(e)}
                            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                        />
                    </div>
                    <div>
                        <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                            Caracteres restantes: {contadorCaracteresRestantes(2000, observacionesReporteEntidad)}
                        </p>
                    </div>
                </div>

                <div>
                    <Label htmlFor="observacionesInternas">Observaciones internas</Label>
                    <div className="mt-2">
                        <textarea                        
                            id="observacionesInternas"
                            name="observacionesInternas"
                            placeholder="Ingrese observaciones internas"
                            rows="4"
                            value={observacionesInternas}
                            maxLength="2000"
                            onChange={handleObservacionesInternasChange}
                            //onChange={e => handleInputChange(e)}
                            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                        />
                    </div>
                    <div>
                        <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                            Caracteres restantes: {contadorCaracteresRestantes(2000, observacionesInternas)}
                        </p>
                    </div>
                </div>
            </div>

            <div className="space-y-4">
                <div className="flex flex-row">
                    <h4 className="text-md font-semibold mb-3 text-gray-700">Tramitación Externa</h4>
                    <InfoButtonWithPopover infoText="EN TESTEO." />
                </div>

                {/* Mostrar al menos una fila vacía si no hay datos */}
                {(!tramitacionesExternas || tramitacionesExternas.length === 0) ? (
                    <TramitacionExternaRow
                        key="nueva-tramitacion"
                        tramitacion={tramitacionesExternas[0]}
                        onUpdate={handleTramitacionExternaUpdate}
                        showHeaderLabels={true}
                    />
                ) : (
                    // Mostrar filas existentes
                    tramitacionesExternas.map((tramitacion, index) => (
                        <TramitacionExternaRow
                            key={tramitacion.id || `tramitacion-${index}`}
                            tramitacion={tramitacion}
                            onUpdate={handleTramitacionExternaUpdate}
                            showHeaderLabels={index === 0}
                        />
                    ))
                )}
                
                <div>
                    <Label htmlFor="observacionesTramitacionExterna">Observaciones a la tramitación externa</Label>
                    <div className="mt-2">
                        <textarea
                        id="observacionesTramitacionExterna"
                        name="observacionesTramitacionExterna"
                        placeholder="Ingrese observaciones a la tramitación externa"
                        rows="4"
                        value={observacionesTramitacionExterna}
                        maxLength="2000"
                        onChange={handleObservacionesTramitacionExternaChange}
                        //onChange={e => handleInputChange(e)}
                        className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                    />
                    </div>
                    <div>
                        <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                            Caracteres restantes: {contadorCaracteresRestantes(2000, observacionesTramitacionExterna)}
                        </p>
                    </div>
                </div>
            </div>           

        </div>
    );   

}

export default FormB_Tramitacion;
